import { render, staticRenderFns } from "./DialogRoom.vue?vue&type=template&id=0f022c04&scoped=true&"
import script from "./DialogRoom.vue?vue&type=script&lang=ts&"
export * from "./DialogRoom.vue?vue&type=script&lang=ts&"
import style0 from "./DialogRoom.vue?vue&type=style&index=0&id=0f022c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f022c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
